import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "content"]

  connect() {
    console.log("Sidebar controller connected")
  }

  toggle() {
    this.menuTarget.classList.toggle("is-hidden-mobile")
    this.menuTarget.classList.toggle("is-hidden-tablet-only")
    
    // Toggle width for desktop viewing
    if (this.menuTarget.classList.contains("is-hidden-desktop")) {
        this.menuTarget.classList.remove("is-hidden-desktop")
    } else {
        this.menuTarget.classList.add("is-hidden-desktop")
    }
  }
}
